// filepath: /Users/sjuul/workspace/robust-risk/frontend/src/models/bucketConfig.ts

export enum BucketType {
  MANAGED = 'managed',
  USER_PROVIDED = 'user_provided',
}

export interface BucketConfig {
  id: number;
  bucket_type: string;
  bucket_name: string;
  endpoint_url?: string | null;
  access_key_id?: string | null;
  region?: string | null;
  is_default: boolean;
  is_active: boolean;
  organization_id: number;
  created_at: string;
  updated_at: string;
  masked_secret: string;
}

export interface BucketConfigCreate {
  bucket_type?: string;
  bucket_name?: string | null;
  endpoint_url?: string | null;
  access_key_id?: string | null;
  secret_access_key?: string | null;
  region?: string | null;
  is_default?: boolean;
}

export interface BucketConfigUpdate {
  is_default?: boolean | null;
  is_active?: boolean | null;
}

